import { Container, Row, Col, Form, Button, Spinner, Alert } from 'react-bootstrap'
import { useState, useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import API from '../api/api'
import Actions from '../redux/actions'

export default function AddUserForm(props) {

    const [fName, setFName] = useState('')
    const [lName, setLName] = useState('')
    const [email, setEmail] = useState('')
    const [loading, setLoading] = useState(false)
    const [err, setErr] = useState('')
    const dispatch = useDispatch()


    useEffect(() => {

    }, [])


    const createUser = async (e) => {
        e.preventDefault()
        setLoading(true)
        const newUser = {
            fName,
            lName,
            email
        }
        if (props.signup) {
            const checkEmail = await API.checkIfEmailExists(email)
            if (checkEmail.found) {
                setErr('Email Already Exists')
                setLoading(false)
            } else {
                props.submit(newUser)

            }

        } else {
            const res = await API.addUser(newUser)
            if (res.err) {
                setErr(res.err)
                setLoading(false)
            } else {
                //add user to list
                dispatch(Actions.setToast(`${res.user.fName} ${res.user.lName} Added ✅`, `An email was sent to ${res.user.email} with sign in instructions`))
               
                dispatch(Actions.addUser(res.user))
                props.close()
            }
        }



    }


    return (
        <Container>
            <Form className='mt-4' onSubmit={createUser}>
                <Form.Group className="mb-3 text-start">
                    <Form.Label className='text-start'>Email</Form.Label>
                    <Form.Control required type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" />
                    <Form.Text className="text-muted text-center">
                        A one-time sign on link will be emailed to this user to create a password
                    </Form.Text>
                </Form.Group>

                <Form.Group className="mb-3 text-start">
                    <Form.Label className='text-start'>First Name</Form.Label>
                    <Form.Control required type="text" value={fName} onChange={e => setFName(e.target.value)} placeholder="First Name" />
                </Form.Group>

                <Form.Group className="mb-3 text-start">
                    <Form.Label className='text-start'>Last Name</Form.Label>
                    <Form.Control required type="text" value={lName} onChange={e => setLName(e.target.value)} placeholder="Last Name" />
                </Form.Group>



                {loading && <div className='text-center my-2'><Spinner animation='border'></Spinner></div>}
                {err !== '' && <Alert variant='danger'>Error: {err}</Alert>}
                <div className='text-center mt-4'>
                    <Button type='submit' disabled={loading}>Create User</Button>
                </div>

            </Form>
        </Container>
    )
}